import { render, staticRenderFns } from "./ViewJob.vue?vue&type=template&id=41d27b95&scoped=true"
import script from "./ViewJob.vue?vue&type=script&lang=js"
export * from "./ViewJob.vue?vue&type=script&lang=js"
import style0 from "./ViewJob.vue?vue&type=style&index=0&id=41d27b95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d27b95",
  null
  
)

export default component.exports